module.exports = __webpack_public_path__ + "img/image11.6b6606ac.jpeg";